import {
  useModalContext,
  WSButton,
  WSButtons,
  WSFormOld,
  WSModal,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { CREATE_PHYSICAL_DEBIT_CARD_MODAL } from "../components/BankCardsList/CreatePhysicalCard";

export const REPLACE_CARD_CONFIRMATION_MODAL =
  "REPLACE_CARD_CONFIRMATION_MODAL";

const Inner: React.FC<{ cardId: string }> = props => {
  const { closeModal, openModal } = useModalContext();

  return (
    <>
      <WSText.Heading5 mb="XL">Order a replacement card?</WSText.Heading5>
      <WSText>
        We will send you an activated replacement card with the same card number
        and PIN.
      </WSText>

      <WSFormOld
        onSubmit={async () => {
          closeModal(REPLACE_CARD_CONFIRMATION_MODAL);
          openModal(CREATE_PHYSICAL_DEBIT_CARD_MODAL, {
            callback() {}
          });
        }}
      >
        <WSButtons mt="XL" format="modal">
          <WSFormOld.SubmitButton>Replace</WSFormOld.SubmitButton>
          <WSButton.Secondary
            onClick={() => closeModal(REPLACE_CARD_CONFIRMATION_MODAL)}
          >
            Cancel
          </WSButton.Secondary>
        </WSButtons>
      </WSFormOld>
    </>
  );
};

export const ReplaceCardConfirmation: React.FC<{ cardId: string }> = props => {
  const { closeModal } = useModalContext();

  return (
    <WSModal
      name={REPLACE_CARD_CONFIRMATION_MODAL}
      size="XS"
      onClose={() => closeModal(REPLACE_CARD_CONFIRMATION_MODAL)}
    >
      <Inner cardId={props.cardId} />
    </WSModal>
  );
};
